import React from 'react';
import { formatAttribute } from '../../../utils/helpers';

import Paper from 'material-ui/Paper';
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table';

const IncidentCardBasic = props => {
  const getTableRow = (fields, attributes) => {
    return fields.map(field => {
      const data = formatAttribute(field, attributes[field], 'incident');
      return (
        <TableRow selectable={false} key={data.name}>
          <TableRowColumn>{data.name}</TableRowColumn>
          <TableRowColumn>{data.value}</TableRowColumn>
        </TableRow>
      );
    });
  };

  const generateCardTable = (fields, attributes) => {
    if (!attributes) {
      return null;
    }

    return (
      <Table selectable={false}>
        <TableBody displayRowCheckbox={false}>
          {getTableRow(fields, attributes)}
        </TableBody>
      </Table>
    );
  };

  return (
    <Paper>
      <h4 className="details-card-title">{props.title}</h4>
      {generateCardTable(props.fields, props.attributes)}
    </Paper>
  );
};

export default IncidentCardBasic;



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentDetails/IncidentCardBasic.js